import React from 'react';

import './tooltip.scss';

interface Props {
  content: any;
  direction?: string;
  children?: any;
  style?: any;
}

interface State {
  active: boolean;
}

export default class Tooltip extends React.Component<Props, State> {
  private timeout: any;

  constructor(props) {
    super(props);

    this.state = {
      active: false
    };
  }

  showTip(): void {
    this.timeout = setTimeout(() => {
      this.setState({ active: true });
    }, 400);
  }

  hideTip(): void {
    clearInterval(this.timeout);
    this.setState({ active: false });
  }

  render(): React.ReactNode {
    return (
      <div
        className={'Tooltip-Wrapper'}
        // When to show the tooltip
        onMouseEnter={() => this.showTip()}
        onMouseLeave={() => this.hideTip()}
      >
        {/* Wrapping */}
        {this.props.children}
        {this.state.active && (
          <div
            className={`${'Tooltip-Tip'} ${this.props.direction || 'top'}`}
            style={this.props.style}
          >
            {/* Content */}
            {this.props.content}
          </div>
        )}
      </div>
    );
  }
}
